/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataClientPackageItemResVo
 */
export interface NodataClientPackageItemResVo {
    /**
     * 无数据记录ID
     * @type {number}
     * @memberof NodataClientPackageItemResVo
     */
    id?: number;
    /**
     * 实拍图片 URL（按 nodataId 从 OrderFileAppService 取）
     * @type {string}
     * @memberof NodataClientPackageItemResVo
     */
    imageUrl?: string;
    /**
     * 快递单号
     * @type {string}
     * @memberof NodataClientPackageItemResVo
     */
    trackingNumber?: string;
    /**
     * 到付费用（返送场景展示）
     * @type {number}
     * @memberof NodataClientPackageItemResVo
     */
    carriageForward?: number;
    /**
     * Coupang入库码（返送场景展示）
     * @type {string}
     * @memberof NodataClientPackageItemResVo
     */
    coupangInboundCode?: string;
    /**
     * 登记时间
     * @type {string}
     * @memberof NodataClientPackageItemResVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the NodataClientPackageItemResVo interface.
 */
export function instanceOfNodataClientPackageItemResVo(value: object): value is NodataClientPackageItemResVo {
    return true;
}

export function NodataClientPackageItemResVoFromJSON(json: any): NodataClientPackageItemResVo {
    return NodataClientPackageItemResVoFromJSONTyped(json, false);
}

export function NodataClientPackageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataClientPackageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'carriageForward': json['carriageForward'] == null ? undefined : json['carriageForward'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function NodataClientPackageItemResVoToJSON(json: any): NodataClientPackageItemResVo {
    return NodataClientPackageItemResVoToJSONTyped(json, false);
}

export function NodataClientPackageItemResVoToJSONTyped(value?: NodataClientPackageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'imageUrl': value['imageUrl'],
        'trackingNumber': value['trackingNumber'],
        'carriageForward': value['carriageForward'],
        'coupangInboundCode': value['coupangInboundCode'],
        'createTime': value['createTime'],
    };
}

